import Difficulty from 'app/frontend/types/custom/Difficulty'
import VisualPlan, { VisualScreen } from 'app/frontend/types/custom/VisualPlan'
import { RaidPlanOwner } from './raid_plans'
import { deleteRequest, getRequest, postRequest, putRequest } from '.'

const ownerPath = (owner: RaidPlanOwner) => {
  if (owner.ownerType === 'team')
    return `/api/teams/${owner.ownerId}/visual_plans`
  return '/api/user/visual_plans'
}

const paramsFor = (
  seasonId?: number,
  difficulty?: Difficulty,
  encounterId?: number,
) => {
  return new URLSearchParams(
    Object.entries({
      ...(seasonId ? { season_id: seasonId.toString() } : {}),
      ...(difficulty ? { difficulty } : {}),
      ...(encounterId ? { encounter_id: encounterId.toString() } : {}),
    }),
  ).toString()
}

export const getVisualPlans = async (
  owner: RaidPlanOwner,
  seasonId?: number,
  difficulty?: Difficulty,
  encounterId?: number,
): Promise<VisualPlan[]> => {
  const params = paramsFor(seasonId, difficulty, encounterId)
  return await getRequest(`${ownerPath(owner)}${params ? `?${params}` : ''}`)
}

export const getVisualPlan = async (
  owner: RaidPlanOwner,
  visualId: number,
): Promise<VisualPlan> => {
  return await getRequest(`${ownerPath(owner)}/${visualId}`)
}

export const createVisualPlan = async (
  owner: RaidPlanOwner,
  visualPlan: {
    encounter_id: number
    difficulty: Difficulty
    name: string
    screens?: VisualScreen[]
  },
): Promise<VisualPlan> => {
  return await postRequest(ownerPath(owner), {
    visual_plan: visualPlan,
  })
}

export const updateVisualPlan = async (
  owner: RaidPlanOwner,
  visualId: number,
  visualPlan: {
    name?: string
    screens?: VisualScreen[]
  },
): Promise<VisualPlan> => {
  return await putRequest(`${ownerPath(owner)}/${visualId}`, {
    visual_plan: visualPlan,
  })
}

export const deleteVisualPlan = async (
  owner: RaidPlanOwner,
  visualId: number,
): Promise<{ success: boolean }> => {
  return await deleteRequest(`${ownerPath(owner)}/${visualId}`)
}
